import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  FormHelperText,
  Button,
} from "@material-ui/core";
import { notification, Spin } from "antd";
import axios from "axios";
import { apiCuentas } from "../../config/api.contable";
import InputFile from "../../components/Global/components/InputFile/InputFile";
import SelectSedes from "../Usuarios/SelectSedes";
import sedeactual from "../../config/sedeactual";

const ImportacionTxt = ({ isSuperAdm, sedes }) => {
  const [excelFile, setExcelFile] = useState(null);
  const [selectedFileList, setSelectedFileList] = useState([]);
  const [sede, setsede] = useState(sedeactual.get());
  const [loading, setLoading] = useState(false);

  const uploadFile = async () => {
    setLoading(true);
    try {
      let form = new FormData();
      form.append("file", excelFile);

      await axios.post(
        `${apiCuentas}/import/txt/${sedeactual.getAnio()}/${sedeactual.get()}/${sedeactual.sede_id()}/${
          sedeactual.company().url
        }`,
        form
      );
      notification.success ({
        message:'Importación realizada exitosamente.',
        description:'Los Recibos por Honorarios se importaron correctamente.'
      });
      setExcelFile(null);
      setSelectedFileList([]);
    } catch (error) {
      notification["error"]({
        message: `Ocurrió un error al realizar la operación`,
      });
    } finally {
      setLoading(false);
    }
  };

  function onChangeFile(info) {
    setExcelFile(info.file.originFileObj);
    switch (info.file.status) {
      case "uploading":
        setSelectedFileList([info.file]);
        break;
      case "done":
        setSelectedFileList([info.file]);
        break;
      case "removed":
        setSelectedFileList([]);
        break;
      default:
        console.log("error");
    }
  }

  return (
    <Card>
      <Spin spinning={loading}>
        <CardContent>
          <Typography variant="h4" color="textSecondary">
            Importación de Recibos por Honorarios - Txt
          </Typography>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12}>
              {isSuperAdm ? (
                <>
                  <FormHelperText>SEDES</FormHelperText>
                  <SelectSedes
                    defaultValue={sede}
                    data={sedes}
                    onChangeSelect={(e) => {
                      setsede(e);
                    }}
                  />
                </>
              ) : null}
            </Grid>
            <Grid item xs={8}>
              <InputFile
                onChange={onChangeFile}
                selectedFileList={selectedFileList}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!excelFile || loading}
                onClick={uploadFile}
              >
                Importar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Spin>
    </Card>
  );
};

export default ImportacionTxt;
